<template>
  <v-container>
    <h3 class="mb-5">Edit User Clients</h3>
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="user.username"
          label="Username"
          :rules="[v => !!v || 'Username is a required field']">
        </v-text-field>
        <v-text-field
          v-model="user.email"
          label="Email"
          :rules="[v => !!v || 'Email is a required field']">
        </v-text-field>
        <v-text-field 
          v-if="!user.userId"
          v-model="user.password"
          type="password"
          label="Password"
          :rules="[v => !!v || 'Password is a required field']">
        </v-text-field>
        <v-text-field 
          v-if="!user.userId"
          v-model="user.confirmPassword"
          type="password"
          label="Confirm Password"
          :rules="[(user.password === user.confirmPassword) || 'Confirm Password must match Password field']">
        </v-text-field>
        <user-client
          :clients="clients"
          :userClients="user.clients"
          class="mx-3"
          @updateClient="updateClient"
          @newClient="newClient">
        </user-client>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UserClient from './UserClient'

export default {
  components: {
    UserClient
  },
  props: ['user', 'clients'],
  data () {
    return {
    }
  },
  methods: {
    updateClient (e) {
      this.$emit('clientsUpdated', e)
    },
    newClient () {
      this.$emit('newClient', true)
    }
  }
}
</script>

<style>

</style>
